export enum AddVideoInputNames {
  VIDEO_LINK = 'videoLink',
}
